"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useLocale } from "next-intl";
import { AltegioWidget } from "./custom/altegio-widget";
import CertificatesModal from "./custom/certificates-modal";

function setAltegioHidden(hidden: boolean) {
  document.querySelectorAll<HTMLElement>("a.yButton").forEach((el) => {
    el.style.display = hidden ? "none" : "";
    el.style.visibility = hidden ? "hidden" : "";
    el.style.pointerEvents = hidden ? "none" : "";
  });
}

export default function AppShellClient() {
  const [certOpen, setCertOpen] = useState(false);
  const pathname = usePathname();
  const locale = useLocale();

  useEffect(() => {
    const hideBecauseRoute =
      pathname === "/prices" || pathname.startsWith("/prices/") ||
      pathname === `/${locale}/prices` || pathname.startsWith(`/${locale}/prices/`);

    setAltegioHidden(certOpen || hideBecauseRoute);

    let raf = 0;
    const observer = new MutationObserver(() => {
      if (!certOpen && !hideBecauseRoute) return;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        setAltegioHidden(true);
        raf = 0;
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (raf) cancelAnimationFrame(raf);
    };
  }, [certOpen, locale, pathname]);

  return (
    <>
      <CertificatesModal onOpenChangeExternal={setCertOpen} />
      <AltegioWidget />
    </>
  );
}
